/**
 * Click Effects - Flow Field (port of the Klick registry component
 * ClickFlowField).
 *
 * Registers its effect into the shared runtime registry
 * (window.__myproClickEffectsRegistry). Loaded by the module only when this
 * effect is the selected one on the frontend (or always on the settings
 * screen preview).
 *
 * Build entry: src/js/modules/click-effects/flow-field.js
 * Output:      assets/js/modules/click-effects-flow-field.min.js
 */
(() => {
	var effects = window.__myproClickEffectsRegistry || (window.__myproClickEffectsRegistry = {});
	var systems = effects.systems || (effects.systems = []);

	effects['flow-field'] = {
		spawn: (x, y, useColor) => {
			var dotCount = 40;
			var initialSpeed = 4;
			var fieldStrength = 0.2;
			var fieldScale = 0.05;
			var dotRadius = 1.5;
			var duration = 2000;
			var now = performance.now();

			for (var i = 0; i < dotCount; i++) {
				systems.push({
					x: x,
					y: y,
					vx: (Math.random() - 0.5) * initialSpeed,
					vy: (Math.random() - 0.5) * initialSpeed,
					startTime: now,
					duration: duration,
					fieldStrength: fieldStrength,
					fieldScale: fieldScale,
					dotRadius: dotRadius,
					update: function (c) {
						var elapsed = performance.now() - this.startTime;
						if (elapsed >= this.duration) {
							return false;
						}

						var progress = elapsed / this.duration;
						var alpha = Math.max(0, 1 - progress);

						this.vx += Math.sin(this.y * this.fieldScale) * this.fieldStrength;
						this.vy += Math.cos(this.x * this.fieldScale) * this.fieldStrength;
						this.x += this.vx;
						this.y += this.vy;

						c.beginPath();
						c.arc(this.x, this.y, this.dotRadius, 0, Math.PI * 2);
						c.fillStyle = useColor;
						c.globalAlpha = alpha;
						c.fill();
						c.globalAlpha = 1;

						return true;
					},
				});
			}
		},
	}
})();
